import { Col, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  comprobantePagoShowForm,
  comprobantespagoStartLoad,
} from "../../../actions/comprobante";
import { ButtonUi } from "../../ui/ButtonUi";
import { ComprobantePrintModal } from "../reusable/ComprobantePrintModal";
import { ComprobantePagoSearchFormTable } from "./ComprobantePagoSearchFormTable";
import { ComprobantePagoTable } from "./ComprobantePagoTable";
import { PageHeaderUi } from "../../ui/PageHeaderUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { ComprobantePagoScreen } from "./ComprobantePagoScreen";

export const ComprobantePagoListScreen = ({ handleOpenForm }) => {
  const dispatch = useDispatch();
  const { comprobantespago } = useSelector((state) => state.comprobantepago);
  const handleReLoad = () => {
    dispatch(comprobantespagoStartLoad());
  };

  return (
    <PageHeaderUi
      title="Comprobantes pago"
      subTitle="Listado"
      extra={[
        <ButtonUi
          key="actualizar"
          typeUi={TipoButtonConstants.Actualizar}
          onClick={handleReLoad}
        />,
        <ButtonUi
          key="nuevo"
          typeUi={TipoButtonConstants.Nuevo}
          onClick={handleOpenForm}
        />,
      ]}
    >
      <div style={{ overflow: "hidden" }}>
        <Row>
          <Col sm={32} md={32} xl={24}>
            <ComprobantePagoSearchFormTable />
            <ComprobantePagoTable comprobantes={comprobantespago} />
            <ComprobantePrintModal />
          </Col>
        </Row>
      </div>
    </PageHeaderUi>
  );
};

export const ComprobantePagoList = () => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const handleOpenForm = () => setShowForm(true);
  const handleCloseForm = () => setShowForm(false);
  const hasRun = useRef(false);

  useEffect(() => {
    // console.log("carga");
    // if (!hasRun.current) {
    console.log("solo una vez");
    dispatch(comprobantespagoStartLoad());
    //   hasRun.current = true;
    // }
  }, []);
  if (showForm) {
    return <ComprobantePagoScreen handleCloseForm={handleCloseForm} />;
  } else return <ComprobantePagoListScreen handleOpenForm={handleOpenForm} />;
};

export default ComprobantePagoList;
